'use client'

import { ACCOUNT_DRAWER_HANDLE } from '@/feature/account/services/account.constants'
import {
  toOrdersHistory,
  toWebOrdersHistory,
} from '@/feature/order-history/services/orderHistory.routing'
import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { useCloseDrawer } from '@/ui/drawer/drawer/Drawer.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { NavigationCard } from '@/ui/cards/navigation-card/NavigationCard.client'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import { NavigationHubOrdersDocument } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  query NavigationHubOrders {
    currentUser {
      id
      permissions {
        showOrderHistory
        showStoreOrderHistory
        hasAccessToWebOrders
      }
    }
    config {
      ...OrdersHistoryConfig
    }
  }
`)

export function NavigationHubOrdersTile() {
  const { t } = useTranslation(['accountDrawer'])
  const closeAccountDrawer = useCloseDrawer(ACCOUNT_DRAWER_HANDLE)
  const { data } = useQuery(NavigationHubOrdersDocument, APOLLO_CLIENT_SIDE_OPTIONS)

  const permissions = data?.currentUser?.permissions
  const isOrdersHistoryUnique = !!data?.config?.sales?.isUniqueOrderDetailsDisplayEnabled

  // In unified mode, access is gated on the role-based order-history permissions (the granular
  // hasAccessTo{Web,Store}Orders flags are off in that mode). Otherwise the legacy web access flag.
  const isVisible = isOrdersHistoryUnique
    ? !!permissions?.showOrderHistory || !!permissions?.showStoreOrderHistory
    : !!permissions?.hasAccessToWebOrders
  if (!isVisible) return null

  return (
    <NavigationCard
      className="grow basis-[calc(50%_-_0.25rem)]"
      href={isOrdersHistoryUnique ? toOrdersHistory : toWebOrdersHistory}
      icon={<Icon.PackageCheck />}
      size="lg"
      onPress={() => {
        closeAccountDrawer()
        pushToGtmDataLayer({
          event: 'gaEvent',
          eventCategory: 'layer mon compte',
          eventAction: 'clic section',
          eventLabel: 'mes commandes',
        })
      }}
    >
      {t(isOrdersHistoryUnique ? 'accountDrawer:ordersMixed' : 'accountDrawer:orders')}
    </NavigationCard>
  )
}
